const FORCE_LOGOUT_REFRESH_FAILURE_REASONS = new Set([
    'refresh_rejected',
    'missing_refresh_token',
    'missing_user_data',
    'invalid_user_data',
]);
const SESSION_INVALID_MARKERS = [
    'sessao encerrada',
    'sessao invalida',
    'sessao invalidada',
    'session invalid',
    'token invalido',
    'token expirado',
    'jwt expired',
    'refresh token expirado',
    'refresh token invalido',
    'token de autenticacao ausente',
    'token de acesso necessario',
    'signature verification failed',
];
const NON_SESSION_401_MARKERS = ['sem permissao', 'nao autorizado nesta conversa', 'forbidden'];
const normalizeText = (value) => {
    if (typeof value !== 'string') {
        return '';
    }
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};
const extractErrorMessage = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return '';
    }
    const data = payload;
    const candidates = [data.erro, data.error, data.mensagem, data.message, data.detail];
    for (const candidate of candidates) {
        const normalized = normalizeText(candidate);
        if (normalized) {
            return normalized;
        }
    }
    return '';
};
export const shouldForceLogoutAfterRefreshFailure = (refreshResult) => {
    if (refreshResult.success) {
        return false;
    }
    return FORCE_LOGOUT_REFRESH_FAILURE_REASONS.has(refreshResult.reason);
};
export const isSessionInvalid401 = (statusCode, payload) => {
    if (statusCode !== 401) {
        return false;
    }
    const message = extractErrorMessage(payload);
    if (!message) {
        return false;
    }
    if (NON_SESSION_401_MARKERS.some(marker => message.includes(marker))) {
        return false;
    }
    return SESSION_INVALID_MARKERS.some(marker => message.includes(marker));
};
